module.exports = __webpack_public_path__ + "static/media/fvs_valve1_116.73293ad7.jpg";